// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"c11a65cf","983":"8fd8e091"}[chunkId] + ".chunk.js";
};